/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "circle-solid-green",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fillRule": "evenodd",
                "clipRule": "evenodd",
                "fill": "#367C2B"
            },
            "circleSolidGreen": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "10",
            "height": "10"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10 10", className: "circle-solid-green", width: this.props.width, height: this.props.height, style: this.props.circleSolidGreen },
            _react2["default"].createElement("circle", { className: "st0", cx: "5", cy: "5", r: "5", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/circle-solid-green.js